import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, LoadSaveService) {

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.updateCoverages = LoadSaveService.updateSubmissionCoverages;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'qnb.LoadSaveService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/controllers/CPPGeneralCoveragesCtrl.js
// module id = 825
// module chunks = 0